import { FC, useEffect } from "react";
import { PageContent } from "../../../components/layout";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { SocialLinksList } from "../../../widgets/social/SocialLinks";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { Configuration, SiteType, TeamContext } from "../../../types/common";
import { ContactItem } from "./ContactItem";
import { AccreditationForm } from "./AccreditationForm";
import YandexMap, { MapPinIcon } from "./Map";
import { ContactUsWidget } from "./ContactUs";
import { setDocumentTitle } from "../../../utils";

export const ContactsPage: FC = () => {
    const config: Configuration = useConfiguration();
    const isAcademy = config.teamName === TeamContext.ACADEMY;
    const socialLinksTeam = config.teamName === TeamContext.RODINA_M || config.teamName === TeamContext.ACADEMY ? TeamContext.ACADEMY : TeamContext.RODINA;
    const hasAccreditation = isAcademy;

    const phoneNumber = isAcademy ? '+7 (495) 963-81-97' : '+7 (499) 918 00 35';

    useEffect(() => {
        setDocumentTitle(`Контакты - Официальный сайт ${config.site === SiteType.LEGACY_ACADEMY ? "Академия" : "ФК"} «Родина»`);
    }, [config.site])

    return (
        <div className="p-2 py-6 max-w-[1024px] mx-auto">
            <h1 className="text-3xl sm:text-4xl font-bold text-center sm:text-left">Контакты</h1>
            <h3 className="text-2xl py-3">Офис футбольного клуба «Родина»</h3>
            <div className="flex flex-col gap-4 items-start p-2">
                {!isAcademy && <ContactItem
                    icon={<PhoneOutlined className="text-3xl text-sky-950" />}
                    text={`Телефон: ${phoneNumber}`}
                />}
                <ContactItem
                    icon={<a href="mailto:info@fcrodina.com"><MailOutlined className="transition-all text-sky-950 text-3xl hover:scale-105" /></a>}
                    text={<>Электронная почта: <a href="mailto:info@fcrodina.com">info@fcrodina.com</a></>}
                />
                <ContactItem
                    icon={<MapPinIcon />}
                    text="Россия, 107258, г. Москва, ул. 3-я Гражданская, 47"
                />
            </div>
            <div className="flex flex-col sm:flex-row gap-2 py-4 sm:py-0 sm:gap-4 items-center sm:justify-between">
                <div className="w-full sm:w-1/2">
                    <hr className="border-0 border-t border-solid border-gray-200 pb-3" />
                    <div className="flex flex-col sm:flex-row gap-2 items-center text-lg">
                        <span>Мы в соцсетях:</span><SocialLinksList className="!gap-3" iconClassName="!h-9 !w-9" teamContext={socialLinksTeam} />
                    </div>
                    <hr className="border-0 border-b border-solid border-gray-200 pt-3" />
                </div>
                <ContactUsWidget />
            </div>
            {hasAccreditation && <div className="py-6 flex flex-col gap-2">
                <h3 className="text-2xl">Аккредитация СМИ на матчи ЮФЛ</h3>
                <ContactItem
                    icon={<a title="Контактный e-mail" href="mailto:polyakov@fcrodina.com"><MailOutlined className="transition-all text-sky-950 text-3xl hover:scale-105" /></a>}
                    text={<>Контактный e-mail: <a href="mailto:polyakov@fcrodina.com">polyakov@fcrodina.com</a></>}
                />
                {hasAccreditation && <AccreditationForm />}
            </div>}
            <h3 className="text-2xl">Расположение на Яндекс.карте</h3>
            <YandexMap />
        </div>
    );
}